const dtGenerator = require('../../../../../components/dt/dt-generator');
const dtHandler = require('../../../../../components/dt/dt-handler');
const itemDtSelect = require('./item-dt-select');
const itemMenu = require('./item-menu');
const { organizeRow } = require('./item-dt-handler');
const { tableDetail } = require('./item-dt-handler');
const treemap = require('./chart/item-treemap-chart');
const inf = require('../../../../../js-network/inf');
const dbRequest = require('../../../../../js-network/db-request');

const ITEM_TREEMAP_LIMIT = '40';

/****************ELEMENTS*****************/
var htmlDt = {};
var HTMLwasSelected = false;
let lastItemSelectDetail = null;

function rememberSelectDetail(detail) {
	lastItemSelectDetail = detail;
}

function HTMLselect() {
	dtHandler.HTMLselect('item-dt', htmlDt, organizeRow, tableDetail);
	HTMLwasSelected = true;
}
/****************ELEMENTS*****************/

function refreshItemTreemap() {
	if (!lastItemSelectDetail || !htmlDt.footer) {
		return;
	}
	const detailTreemap = { ...lastItemSelectDetail };
	inf.toSelect(detailTreemap, htmlDt);
	detailTreemap.inf = Object.assign({}, detailTreemap.inf, { limit2: ITEM_TREEMAP_LIMIT });

	dbRequest
		.start(detailTreemap, 'server/php/sql/select.php')
		.then((result) => {
			if (result.status === 'ok' && Array.isArray(result.data)) {
				treemap.createTreemapChart(result.data);
			}
		})
		.catch(() => {});
}

function afterTableSelect() {
	refreshItemTreemap();
}

export function start(detail) {
	if (!HTMLwasSelected) {
		HTMLselect();
	}

	obj[detail.act].start(detail);
}

const obj = {
	//From fullcont connection
	addRow: { start: (detail) => {
		dtGenerator.addRow(detail, htmlDt);
	} },
	tableOptions: { start: (detail) => {
		itemMenu.start(detail, htmlDt, 'htmlFc');
	} },
	trMenu: { start: (detail) => {
		itemMenu.start(detail, htmlDt, 'htmlFc');
	} },
	updateRow: { start: (detail) => {
		dtGenerator.updateRow(detail, htmlDt);
	} },

	//data table (item-local select stack + treemap refresh)
	filter: { start: (detail) => {
		rememberSelectDetail(detail);
		itemDtSelect.filter(detail, htmlDt, afterTableSelect);
	} },
	filterShowHide: { start: (detail) => {
		rememberSelectDetail(detail);
		itemDtSelect.filterShowHide(detail, htmlDt, afterTableSelect);
	} },
	loadMore: { start: (detail) => {
		rememberSelectDetail(detail);
		itemDtSelect.loadMore(detail, htmlDt, afterTableSelect);
	} },
	searching: { start: (detail) => {
		rememberSelectDetail(detail);
		itemDtSelect.searching(detail, htmlDt, undefined, afterTableSelect);
	} },
	select: { start: (detail) => {
		rememberSelectDetail(detail);
		itemDtSelect.select(detail, htmlDt, true, afterTableSelect);
	} },
	th: { start: (detail) => {
		rememberSelectDetail(detail);
		itemDtSelect.th(detail, htmlDt, afterTableSelect);
	} },
	trPrint: { start: (detail) => {
		trPrint(detail);
	} },
};

function trPrint(detail) {}
